import _keyBy from 'lodash/keyBy';
import { useQuery } from '@apollo/client';
import { GetLicensedApplications } from '@resources/configuration.graphql';

export const AWARE_TEST_BUILDER = 91;
export const AWARE_PREMIUM = 94;
export const AWARE = 9;
const STRIVE_EVALUATION = 15;
export const STRIVE_PROFESSIONAL_DEVELOPMENT = 16;

export const useLicenseCheck = ids => {
  /* ids = array of license ids */
  const { data: licensedData, loading } = useQuery(GetLicensedApplications);

  const licensedApplications = licensedData?.licensedApplications || [];
  const licensesById = _keyBy(licensedApplications, 'applicationId');
  const includesLicenses = ids.every(
    id => licensesById[id]?.hasLicense && licensesById[id]?.valid
  );

  return { includesLicenses, isLoading: loading };
};

export const useGetStriveLicense = () => {
  const {
    includesLicenses: hasEvaluationEdition,
    isLoading: isLoadingEvaluationEditionLicense
  } = useLicenseCheck([STRIVE_EVALUATION]);
  const {
    includesLicenses: hasProfessionalLearningEdition,
    isLoading: isloadingProfessionalDevelopmentEditionLicense
  } = useLicenseCheck([STRIVE_PROFESSIONAL_DEVELOPMENT]);

  const isLoading =
    isLoadingEvaluationEditionLicense || isloadingProfessionalDevelopmentEditionLicense;

  return {
    hasEvaluationEdition,
    hasProfessionalLearningEdition,
    isLoading
  };
};
